export default "__VITE_ASSET__B94sQ_ND__"